import { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { RootState } from 'reducers';
import { connect } from 'react-redux';
import { Form } from "antd";
import { createEntity, getEntity, reset, updateEntity } from "./relationshipTree.reducer";
import EditPage, { EditStateAndDispatchProps } from "layouts/page-wraper/edit-page-modal"
import { RelationshipTree } from "model/dealer/relationshipTree.model";
export interface RelationshipTreeEditProps extends EditStateAndDispatchProps<RelationshipTree>, StateProps, DispatchProps, RouteComponentProps {
}

const RelationshipTreeEdit: FC<RelationshipTreeEditProps> = props => {
  const [form] = Form.useForm();
  return (
    <EditPage<RelationshipTree>
      title=""
      form={form}
      {...props}
    >
    </EditPage>);
};

const mapStateToProps = ({ relationshipTree }: RootState) => ({
  entity: relationshipTree.entity,
  updateSuccess: relationshipTree.updateSuccess,
  updating: relationshipTree.updating,
  createSuccess: relationshipTree.createSuccess
});

const mapDispatchToProps = {
  getEntity,
  createEntity,
  updateEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RelationshipTreeEdit);
